import { render, staticRenderFns } from "./userDetailGroupOrders.vue?vue&type=template&id=6985f1c9&scoped=true"
import script from "./userDetailGroupOrders.vue?vue&type=script&lang=js"
export * from "./userDetailGroupOrders.vue?vue&type=script&lang=js"
import style0 from "./userDetailGroupOrders.vue?vue&type=style&index=0&id=6985f1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6985f1c9",
  null
  
)

export default component.exports